/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  UpdateUserMetadataRequest,
  UpdateUserMetadataResponse,
  UserResponse
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Delete authenticated user account and all associated data.
 *
 * Performs hard deletion with CASCADE cleanup:
 * - User row deleted from database
 * - Topics cascade (ON DELETE CASCADE)
 * - Connections cascade (ON DELETE CASCADE)
 * - Messages cascade (ON DELETE CASCADE)
 * - User deleted from Clerk authentication system
 *
 * Authentication via Bearer token. Rate limited per user_deletion category.
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     HTTPException: 429 if rate limit exceeded
 *     UserNotFoundError: 404 if user not found in database
 * @summary Delete User Account
 */
export const deleteUserAccountV1UsersMeDelete = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/users/me`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteUserAccountV1UsersMeDeleteMutationKey = () => ['deleteUserAccountV1UsersMeDelete'] as const;

export const getDeleteUserAccountV1UsersMeDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>, TError,void, TContext> => {

const mutationKey = getDeleteUserAccountV1UsersMeDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>, void> = () => {


          return  deleteUserAccountV1UsersMeDelete(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserAccountV1UsersMeDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>>

    export type DeleteUserAccountV1UsersMeDeleteMutationError = unknown


    /**
 * @summary Delete User Account
 */
export const useDeleteUserAccountV1UsersMeDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserAccountV1UsersMeDelete>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteUserAccountV1UsersMeDeleteMutationOptions(options), queryClient);
    }
    /**
 * Get current authenticated user information.
 *
 * Returns user data including trial status, activation status, and onboarding state.
 * All datetime fields are serialized to ISO 8601 format.
 *
 * Args:
 *     current_user: Authenticated user from bearer token
 *
 * Returns:
 *     User information with trial tracking fields
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     UserNotFoundError: 404 if user not found in database
 *     AccountSuspendedError: 403 if user account is suspended or deleted
 *     TrialExpiredError: 403 if user trial has expired
 * @summary Get Current User Info
 */
export const getCurrentUserInfoV1UsersMeGet = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<UserResponse>(
      {url: `/v1/users/me`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentUserInfoV1UsersMeGetQueryKey = () => {
    return [
    `/v1/users/me`
    ] as const;
    }


export const getGetCurrentUserInfoV1UsersMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserInfoV1UsersMeGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>> = ({ signal }) => getCurrentUserInfoV1UsersMeGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserInfoV1UsersMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>>
export type GetCurrentUserInfoV1UsersMeGetQueryError = unknown


export function useGetCurrentUserInfoV1UsersMeGet<TData = Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserInfoV1UsersMeGet<TData = Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserInfoV1UsersMeGet<TData = Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current User Info
 */

export function useGetCurrentUserInfoV1UsersMeGet<TData = Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoV1UsersMeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserInfoV1UsersMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update user metadata in Clerk publicMetadata.
 *
 * Supports partial updates - only provided fields are updated.
 * Attribution data has write-once protection (immutable after first write).
 * Auto-creates user in database on first metadata update.
 *
 * Args:
 *     req_obj: Metadata update request with optional fields
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user (auto-created if first login)
 *
 * Returns:
 *     Success flag and updated publicMetadata from Clerk
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     RegistrationClosedError: If user creation is restricted
 *     AccountSuspendedError: If user account is banned
 *     ClerkAPIError: If Clerk API call fails
 * @summary Update Metadata
 */
export const updateMetadataV1UsersMetadataPost = (
    updateUserMetadataRequest: UpdateUserMetadataRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<UpdateUserMetadataResponse>(
      {url: `/v1/users/metadata`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserMetadataRequest, signal
    },
      options);
    }




export const getUpdateMetadataV1UsersMetadataPostMutationKey = () => ['updateMetadataV1UsersMetadataPost'] as const;

export const getUpdateMetadataV1UsersMetadataPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>, TError,UpdateMetadataV1UsersMetadataPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>, TError,UpdateMetadataV1UsersMetadataPostMutationVariables, TContext> => {

const mutationKey = getUpdateMetadataV1UsersMetadataPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>, UpdateMetadataV1UsersMetadataPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMetadataV1UsersMetadataPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMetadataV1UsersMetadataPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>>
    export type UpdateMetadataV1UsersMetadataPostMutationBody = UpdateUserMetadataRequest
    export type UpdateMetadataV1UsersMetadataPostMutationError = HTTPValidationError
    export type UpdateMetadataV1UsersMetadataPostMutationVariables = {data: UpdateUserMetadataRequest}

    /**
 * @summary Update Metadata
 */
export const useUpdateMetadataV1UsersMetadataPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>, TError,UpdateMetadataV1UsersMetadataPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMetadataV1UsersMetadataPost>>,
        TError,
        UpdateMetadataV1UsersMetadataPostMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMetadataV1UsersMetadataPostMutationOptions(options), queryClient);
    }
